import { useMutation, useQueryClient } from "@tanstack/react-query";
import { isFunction } from "lodash";

import { deleteRow } from "@services/subscriberSyncUpload";

// Mirrors useDeleteMeterUploadDraft's shape: always invalidate the draft detail + upload-history
// queries, THEN run any caller onSuccess. Used by the review grid's per-row Delete action.
export const useDeleteSubscriberSyncRow = ({
  onSuccess,
  ...options
}: Record<string, any> = {}) => {
  const queryClient = useQueryClient();
  return useMutation(
    (params: { uploadId: string; rowId: string }) => deleteRow(params),
    {
      ...options,
      onSuccess: (res: void, variables: { uploadId: string; rowId: string }) => {
        queryClient.invalidateQueries({
          queryKey: ["subscriberSyncUpload", variables.uploadId],
        });
        queryClient.invalidateQueries({ queryKey: ["subscriberSyncUploads"] });
        if (isFunction(onSuccess)) onSuccess(res, variables);
      },
    },
  );
};
